import checkmarkWhiteData from '@datacamp/waffles-animations/checkmark-white.json';
import { Paragraph } from '@datacamp/waffles-text';
import Lottie from 'lottie-react';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const EarnedXp = _ref => {
  let {
    className,
    xp
  } = _ref;
  return ___EmotionJSX("div", {
    className: className
  }, ___EmotionJSX("div", {
    style: {
      height: 50,
      margin: 'auto',
      width: 50
    }
  }, ___EmotionJSX(Lottie, {
    animationData: checkmarkWhiteData,
    loop: false
  })), ___EmotionJSX(Paragraph, {
    className: "dc-u-color-white dc-u-mt-12 dc-u-ta-center"
  }, "+", xp, " XP"));
};
export default EarnedXp;